import axiosInst from 'api/axios';
import classNames from 'classnames';
import { AllRoutes } from 'constants/routes';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from 'redux/appReducer';
import { getPdf } from 'utils/getPdf';
import styles from './Accounts.module.scss';

const ITEMS_PER_RAGE = 10;

export const Facturas = () => {
  const { state, getFacturas, getFacturasCount } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const sendToTG = (id, num, date, year) => {
    setLoading(true);
    axiosInst()
      .get(`/facturas/sendTG/${id}?date=${date}&name=${`factura-${year}${('000' + num).slice(-4)}`}`)
      .catch((e) => console.log(e))
      .finally(() => setLoading(false));
  };

  const getFactura = (id, num, date) => {
    setLoading(true);
    const url = `/factura/pdf/${id}?date=${date}`;
    const name = `factura-${('000' + num).slice(-4)}.pdf`;
    getPdf(url, name, setLoading, id);
  };

  useEffect(() => {
    axiosInst()
      .get('/facturas')
      .then((res) => {
        getFacturas(res.data?.accounts);
        getFacturasCount(res.data?.count);
      })
      .catch((e) => console.log(e));
  }, []);

  const showMore = () => {
    axiosInst()
      .get(`/facturas?offset=${state.facturas.length}&limit=${ITEMS_PER_RAGE}`)
      .then((res) => {
        getFacturas([...state.facturas, ...res.data?.facturas]);
      })
      .catch((e) => console.log(e));
  };

  return (
    <>
      <div className={styles.container}>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              <th>№ Factura</th>
              <th>Fecha</th>
              <th>Cliente</th>
              <th>total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {state.facturas.map((item) => (
              <tr
                key={item._id}
                className={classNames(styles.account, loading && styles.isLoading)}
                onClick={() => {
                  navigate(AllRoutes.facturas + '/' + item._id);
                }}
              >
                <td>
                  {item.year}
                  {`000${item.number}`.slice(-4)}
                </td>
                <td className={styles.date}>{item.date}</td>
                <td>{item.name}</td>
                <td>{item.total}</td>
                <td className={styles.buttons}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      !loading && getFactura(item._id, item.number, item.date);
                    }}
                  >
                    <svg width='21px' height='21px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        fill-rule='evenodd'
                        clip-rule='evenodd'
                        d='M12 3C12.5523 3 13 3.44772 13 4V12.5858L15.2929 10.2929C15.6834 9.90237 16.3166 9.90237 16.7071 10.2929C17.0976 10.6834 17.0976 11.3166 16.7071 11.7071L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L7.2929 11.7071C6.90238 11.3166 6.90238 10.6834 7.2929 10.2929C7.68342 9.90237 8.31659 9.90237 8.70711 10.2929L11 12.5858V4C11 3.44772 11.4477 3 12 3ZM4.00001 14C4.55229 14 5.00001 14.4477 5.00001 15C5.00001 15.9772 5.00485 16.3198 5.05765 16.5853C5.29437 17.7753 6.22466 18.7056 7.41474 18.9424C7.68018 18.9952 8.02276 19 9.00001 19H15C15.9772 19 16.3198 18.9952 16.5853 18.9424C17.7753 18.7056 18.7056 17.7753 18.9424 16.5853C18.9952 16.3198 19 15.9772 19 15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15C21 15.0392 21 15.0777 21 15.1157C21.0002 15.9334 21.0004 16.4906 20.9039 16.9755C20.5094 18.9589 18.9589 20.5094 16.9755 20.9039C16.4907 21.0004 15.9334 21.0002 15.1158 21C15.0778 21 15.0392 21 15 21H9.00001C8.96084 21 8.92225 21 8.88423 21C8.06664 21.0002 7.50935 21.0004 7.02456 20.9039C5.0411 20.5094 3.49061 18.9589 3.09608 16.9755C2.99965 16.4906 2.99978 15.9334 2.99999 15.1158C3 15.0777 3.00001 15.0392 3.00001 15C3.00001 14.4477 3.44772 14 4.00001 14Z'
                        fill='#0F1729'
                      />
                    </svg>
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      !loading && sendToTG(item._id, item.number, item.date, item.year);
                    }}
                  >
                    <svg width='21px' height='21px' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <circle cx='16' cy='16' r='14' fill='url(#paint0_linear_87_7225)' />
                      <path
                        d='M22.9866 10.2088C23.1112 9.40332 22.3454 8.76755 21.6292 9.082L7.36482 15.3448C6.85123 15.5703 6.8888 16.3483 7.42147 16.5179L10.3631 17.4547C10.9246 17.6335 11.5325 17.541 12.0228 17.2023L18.655 12.6203C18.855 12.4821 19.073 12.7665 18.9021 12.9426L14.1281 17.8646C13.665 18.3421 13.7569 19.1512 14.314 19.5005L19.659 22.8523C20.2585 23.2282 21.0297 22.8506 21.1418 22.1261L22.9866 10.2088Z'
                        fill='white'
                      />
                      <defs>
                        <linearGradient
                          id='paint0_linear_87_7225'
                          x1='16'
                          y1='2'
                          x2='16'
                          y2='30'
                          gradientUnits='userSpaceOnUse'
                        >
                          <stop stop-color='#37BBFE' />
                          <stop offset='1' stop-color='#007DBB' />
                        </linearGradient>
                      </defs>
                    </svg>
                  </button>
                  <button>
                    <svg
                      fill='#000000'
                      width='17px'
                      height='17px'
                      viewBox='0 0 1920 1920'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M277.974 49.076c65.267-65.379 171.733-65.49 237.448 0l232.186 232.187 1055.697 1055.809L1919.958 1920l-582.928-116.653-950.128-950.015 79.15-79.15 801.792 801.68 307.977-307.976-907.362-907.474L281.22 747.65 49.034 515.464c-65.379-65.603-65.379-172.069 0-237.448Zm1376.996 1297.96-307.977 307.976 45.117 45.116 384.999 77.023-77.023-385-45.116-45.116ZM675.355 596.258l692.304 692.304-79.149 79.15-692.304-692.305 79.149-79.15ZM396.642 111.88c-14.33 0-28.547 5.374-39.519 16.345l-228.94 228.94c-21.718 21.718-21.718 57.318 0 79.149l153.038 153.037 308.089-308.09-153.037-153.036c-10.972-10.971-25.301-16.345-39.63-16.345Z'
                        fill-rule='evenodd'
                      />
                    </svg>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {state.facturas.length < state.getFacturasCount && (
          <div className={styles.more} onClick={showMore}>
            <div className={styles.arrow}></div>
          </div>
        )}
      </div>
    </>
  );
};
